module.exports = __webpack_public_path__ + "static/network-emulation-c35a577e0b2ed322ab41520436120a7d.png";